import { render, staticRenderFns } from "./StudentOccurrence.vue?vue&type=template&id=0033c51e&"
import script from "./StudentOccurrence.js?vue&type=script&lang=js&"
export * from "./StudentOccurrence.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports